import { createAsyncThunk } from '@reduxjs/toolkit';
import { LocationService } from '../../services';
// eslint-disable-next-line import/no-restricted-paths
import { LocationFilterDTO } from '../../locations/types';
// eslint-disable-next-line import/no-restricted-paths
import { LocationLightDTO } from '../../services/location.service';

type GetSharedLocationsPayload = {
  filters?: LocationFilterDTO;
  onSuccess?: (response: LocationLightDTO[]) => void;
};

export const getSharedLocations = createAsyncThunk(
  'shared/locations',
  async (
    { filters, onSuccess }: GetSharedLocationsPayload,
    { rejectWithValue },
  ) => {
    const { ok, data, error } = await LocationService.getLocations(filters);

    if (ok) {
      onSuccess?.(data.items);
      return data;
    }
    return rejectWithValue(error);
  },
);
